/** New version of admin details to phase out view page/review pages created one off for various record types */
import { Dropdown, DropdownItem, Tabs } from '@platform/components';
import { AdminTableProvider } from './AdminTable';

type DetailsPageProps = {
  tabs: { id: string; content: React.ReactNode }[];
  title: string;
  pageActions?: DetailPageAction[];
  isLoading?: boolean;
  isError?: boolean;
  isSuccess?: boolean;
};

export const AdminDetailPage = ({
  title,
  tabs,
  pageActions,
  isLoading,
  isError,
  isSuccess,
}: DetailsPageProps) => {
  return (
    // Some tabs may contain simplified admin tables, provider allows sort/pagination state to be wired in
    <AdminTableProvider>
      <div className='px-32 text-gray-500'>
        <div className='flex justify-between items-center mb-4'>
          <h1 className='text-display-sm font-semibold'>{title}</h1>
          <PageActions actions={pageActions || []} />
        </div>
        {isLoading && <div>Loading...</div>}
        {isError && <div>Error loading data.</div>}
        {isSuccess && <Tabs title={`${title} Details`} items={tabs} variant='side-tabs' />}
      </div>
    </AdminTableProvider>
  );
};

export type DetailPageAction =
  | {
      type: 'link';
      text: string;
      href: string;
      isDanger?: boolean;
    }
  | {
      type: 'button';
      text: string;
      onPress: () => void;
      isDanger?: boolean;
    };

const PageActions = ({ actions }: { actions: DetailPageAction[] }) => {
  return (
    <Dropdown
      type='button'
      buttonProps={{ children: 'Actions', variant: 'tertiary-gray', size: 'sm' }}
      ariaLabel='Page actions'
    >
      {actions.map((action, index) =>
        action.type === 'button' ?
          <DropdownItem
            key={index}
            onAction={() => action.onPress()}
            additionalClassnames={action.isDanger ? 'text-error-600 font-semibold' : ''}
          >
            {action.text}
          </DropdownItem>
        : <DropdownItem
            key={index}
            href={action.href}
            additionalClassnames={action.isDanger ? 'text-error-600 font-semibold' : ''}
          >
            {action.text}
          </DropdownItem>,
      )}
    </Dropdown>
  );
};
